// extracted by mini-css-extract-plugin
export default {"main":"FormikForm--main--T0yJ-","checkBoxDocTooltipLabel":"FormikForm--checkBoxDocTooltipLabel--hKOi3","inlineRadioGroup":"FormikForm--inlineRadioGroup--6jqc+"};